import * as React from 'react'

const SvgRestartIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={20} height={20} viewBox="0 0 20 20" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.625 11.25A6.25 6.25 0 119.375 5h3.863L11 7.244l.875.881 3.75-3.75-3.75-3.75-.875.881 2.244 2.244H9.375a7.5 7.5 0 107.5 7.5h-1.25z"
      fill="#163250"
    />
  </svg>
)

export default SvgRestartIcon
